import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Select,
    MenuItem,
    Typography,
    IconButton,
    Divider,
    Box
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const DashVendaMesClienteDialog = ({ open, onClose, dados, representanteSelecionado, setRepresentanteSelecionado, supervisorSelecionado, setSupervisorSelecionado }) => {
    
    const theme = useTheme(); 
    
    const totalGeral = dados
        .filter(d =>
            (representanteSelecionado ? d.Representante === representanteSelecionado : true) &&
            (supervisorSelecionado ? d.Supervisor === supervisorSelecionado : true)
        ).reduce((acc, item) => acc + (Number(item.PedidoVlrTotal) || 0), 0);

    const totalPedidos = dados
        .filter(d =>
            (representanteSelecionado ? d.Representante === representanteSelecionado : true) &&
            (supervisorSelecionado ? d.Supervisor === supervisorSelecionado : true)
        ).reduce((acc, item) => acc + (Number(item.TotalPedidos) || 0), 0);


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                sx: {
                    width: '100vw',
                    //height: '90vh',
                    borderRadius: 3,
                    backgroundColor: '#1d1d1d',
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.5)'
                }
            }}
        >
            {/* Título com Ícone */}
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: theme.palette.primary.main,
                    color: '#fff',
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12
                }}
            >
                <Box display="flex" alignItems="center">
                    <TrendingUpIcon sx={{ marginRight: 1 }} />
                    <Typography variant="h6">📊 Detalhes por Cliente (Mês)</Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ backgroundColor: '#1d1d1d', p: 3 }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                    <Select
                        value={supervisorSelecionado}
                        onChange={(e) => setSupervisorSelecionado(e.target.value)}
                        fullWidth
                        displayEmpty
                        sx={{
                            mb: 2,
                            backgroundColor: '#2d2d2d',
                            color: '#fff',
                            borderRadius: 2,
                            '& .MuiSelect-icon': { color: '#fff' },
                            marginTop: 2
                        }}
                    >
                        <MenuItem value="">Todos os Supervisores</MenuItem>
                        {[...new Set(dados.map(item => item.Supervisor))].map(rep => (
                            <MenuItem key={rep} value={rep}>{rep}</MenuItem>
                        ))}
                    </Select>

                    <Select
                        value={representanteSelecionado}
                        onChange={(e) => setRepresentanteSelecionado(e.target.value)}
                        fullWidth
                        displayEmpty
                        sx={{
                            mb: 2,
                            backgroundColor: '#2d2d2d',
                            color: '#fff',
                            borderRadius: 2,
                            '& .MuiSelect-icon': { color: '#fff' },
                            marginTop: 2
                        }}
                    >
                        <MenuItem value="">Todos os Representantes</MenuItem>
                        {[...new Set(dados.map(item => item.Representante))].map(rep => (
                            <MenuItem key={rep} value={rep}>{rep}</MenuItem>
                        ))}
                    </Select>
                </div>

                <Divider sx={{ mb: 2, backgroundColor: '#444' }} />

                <Box sx={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ backgroundColor: theme.palette.primary.main, color: '#fff' }}>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Supervisor</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Representante</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Cliente</th>
                                <th style={{ padding: '10px', textAlign: 'right' }}>Rentabilidade</th>
                                <th style={{ padding: '10px', textAlign: 'right' }}>Pedidos</th>
                                <th style={{ padding: '10px', textAlign: 'right' }}>Vlr Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dados.filter(d =>
                                (representanteSelecionado ? d.Representante === representanteSelecionado : true) &&
                                (supervisorSelecionado ? d.Supervisor === supervisorSelecionado : true)
                            ).map((item, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#2d2d2d' : '#1d1d1d',
                                        color: '#fff',
                                        transition: 'background-color 0.3s'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#333'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#2d2d2d' : '#1d1d1d'}
                                >
                                    <td style={{ padding: '10px' }}>{item.Supervisor}</td>
                                    <td style={{ padding: '10px' }}>{item.Representante}</td>
                                    <td style={{ padding: '10px' }}>{item.Cliente}</td>
                                    <td style={{ padding: '10px', textAlign: 'right' }}>
                                        {Number(item.PercRentabilidadeRep).toFixed(2)} %
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'right' }}>{item.TotalPedidos}</td>
                                    <td style={{ padding: '10px', textAlign: 'right' }}>
                                        {(Number(item.PedidoVlrTotal) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr style={{ backgroundColor: '#333', color: '#fff' }}>
                                <td colSpan="4"></td>
                                <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#4caf50' }}>
                                    {totalPedidos}
                                </td>
                                <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#4caf50' }}>
                                    {totalGeral.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </Box>
            </DialogContent>

            {/* Botão Fechar */}
            <DialogActions sx={{ backgroundColor: '#1d1d1d', p: 2 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="error"
                    startIcon={<CloseIcon />}
                    sx={{ fontWeight: 'bold', borderRadius: 2 }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DashVendaMesClienteDialog;
